module.exports = __webpack_public_path__ + "static/media/h2h-logotype-d.fbea9986.svg";